import { EditFormTypes } from "src/common-types";

export const PHENOPHASE_EDIT_LIST_ITEMS: EditFormTypes[] = [
  {
    id: "name",
    label: "Название фенофазы: ",
    inputs: [{ type: "string", placeholder: "Название" }],
  },
];
